<template>
  <section class="ctn">
    <header class="header left">
      <router-link class="paper-action" :to="{ path: '/sites' }"><heim-icon icon="arrow-back"></heim-icon><span>{{ $t('back') }}</span></router-link>
    </header>
    <heim-card>
      <header class="header left">
        <h1>{{ $t('new') }} {{ $t('site') }}</h1>
      </header>
      <main>
        <form @submit.prevent="handleForm">
          <div class="row">
            <span class="label">{{ $t('site') }}</span>
            <div class="inputs">
              <heim-input :label="$t('name') + '*'" name="name" placeholder="e.g : Google" v-model="name" v-validate="'required'"></heim-input>
               <span v-show="errors.has('name')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('name') }}</span>
              <heim-input
                :label="$t('link') + '*'"
                name="url"
                placeholder="https://www.google.com"
                v-model="url"
                 v-validate="'required|url'"
              ></heim-input>
               <span v-show="errors.has('url')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('url') }}</span>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('monitoring') }}</span>
            <div class="inputs">
              <heim-input
                :label="$t('pingInterval') + ' (ms)'"
                name="interval"
                type="number"
                placeholder="300000"
                v-model="interval"
              ></heim-input>
              <heim-input
                :label="$t('referenceTime') + ' (ms)'"
                name="reference_time"
                type="number"
                placeholder="8000"
                v-model="reference_time"
              ></heim-input>
              <heim-input
                :label="$t('errorRecurrence')"
                name="nb_occurence"
                type="number"
                placeholder="2"
                v-model="nb_occurence"
              ></heim-input>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('hostingCosts') }}</span>
            <div class="inputs">
              <heim-input
                :label="$t('invoicedAmount')"
                name="hosting_cost"
                type="number"
                v-model="hosting_cost"
                step="0.01"
              ></heim-input>
              <div class="heim-input date-hosting">
                <div class="date-h">
                  <span class="label">{{ $t('startDate') }}</span>
                  <datepicker 
                  type="date"
                  name="hosting_date_start"
                  input-class="paper-input"
                  wrapper-class="date-input"
                  v-model="hosting_date_start"
                  value-key="id"
                  :disabledDates="disabledDateStart(hosting_date_end)"
                  ></datepicker>
                </div>
                <div class="date-h">
                    <span class="label">{{ $t('endDate') }}</span>
                    <datepicker 
                    type="date"
                    name="hosting_date_end"
                    input-class="paper-input"
                    wrapper-class="date-input"
                    v-model="hosting_date_end"
                    value-key="id"
                    :disabledDates="disabledDateEnd(hosting_date_start)"
                    ></datepicker>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('type') }}</span>
            <div class="inputs">
              <heim-select
                :label="$t('type') + '*'"
                :data="siteTypes"
                label-key="type"
                value-key="id"
                v-model="type"
                required="required"
              ></heim-select>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('server') }}</span>
            <div class="inputs">
              <heim-select
                :label="$t('server') + '*'"
                :data="servers"
                label-key="name"
                value-key="id"
                v-model="server"
                required="required"
              ></heim-select>
            </div>
          </div>
          <footer>
            <heim-button :disabled="errors.any()" type="submit">{{ $t('save') }}</heim-button>
          </footer>
        </form>
      </main>
    </heim-card>
  </section>
</template>

<script>
import Vue from "vue";
import HeimInput from "@/components/form/input/text/heim-input.vue";
import HeimSelect from "@/components/form/input/select/heim-select.vue";
import HeimButton from "@/components/form/button/heim-button.vue";
import HeimCard from "@/components/layout/card/heim-card.vue";
import HeimIcon from "@/components/icon/heim-icon.vue";
import { mapState } from "vuex";
import VeeValidate from "vee-validate";
import Datepicker from "vuejs-datepicker";

Vue.use(VeeValidate);

export default {
  name: "SitesNew",
  components: {
    HeimInput,
    HeimSelect,
    HeimButton,
    HeimCard,
    HeimIcon,
    Datepicker
  },
  mounted() {
    this.$store.dispatch("getSiteTypes");
    this.$store.dispatch("getServers");
    this.$store.dispatch("setTitle", "Create site");
  },
  data() {
    return {
      name: "",
      url: "",
      interval: "300000",
      reference_time: null,
      nb_occurence: 2,
      type: "",
      server: "",
      hosting_cost: "",
      hosting_date_start: "",
      hosting_date_end: ""
    };
  },
  computed: {
    ...mapState({
      siteTypes: state => state.sitesState.siteTypes,
      servers: state => state.serversState.servers
    })
  },
  methods: {
    async handleForm() {
      const data = await this.$store.dispatch("createSite", {
        name: this.name,
        url: this.url,
        interval: this.interval,
        reference_time: this.reference_time,
        nb_occurence: this.nb_occurence,
        type_id: this.type,
        server_id: this.server,
        hosting_cost: this.hosting_cost,
        hosting_date_start: this.hosting_date_start,
        hosting_date_end: this.hosting_date_end
      });

      this.$validator.validateAll().then(result => {
        if (result && data.site.id) {
          this.$store.dispatch("setToastMessage", {
            message: "newSitecreated"
          });
          this.$store.dispatch("setToastMode", {});
          this.$store.dispatch("setOpenToast", { opened: true });
          this.$router.push({ path: `/sites/${data.site.id}/details` });
        }
      });
    },
    disabledDateStart(date) {
      return {
        from: new Date(date)
      };
    },
    disabledDateEnd(date) {
      return {
        to: new Date(date)
      };
    }
  }
};
</script>

<style>
input.paper-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
  margin-bottom: 0.8em;
}
input.paper-input:hover,
input.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.heim-input[icon] input.paper-input {
  padding-right: 32px;
}

.date-input {
  margin-bottom: 20px;
}
</style>

<style scoped>
.heim-input {
  max-width: 32em;
}

.heim-input input {
  width: 100%;
}

.label {
  display: inline-block;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 0.1em;
  font-weight: 500;
}
input.paper-input {
  background: var(--heim-grey-color) !important;
  width: 100% !important;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed !important;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
  margin-bottom: 0.8em;
}
input.paper-input:hover,
input.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}

.vdp-datepicker input {
  width: 100%;
}

.date-input {
  margin-bottom: 20px;
}

.date-input .paper-input {
  width: 100%;
}

.date-hosting {
  display: flex;
  flex-wrap: wrap;
}

.date-hosting .date-h {
  flex: 1;
  padding-right: 20px;
}

.date-hosting .date-h:last-child {
  padding-right: 0px;
}
</style>
